var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgTrailPeriodIsOver(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a8 8 0 100 16 1 1 0 110 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10a1 1 0 11-2 0 8 8 0 00-8-8zm0 1a1 1 0 011 1v5.586l.707.707a1 1 0 01-1.414 1.414l-1-1A1 1 0 0111 12V6a1 1 0 011-1zm4.707 10.293a1 1 0 00-1.414 1.414L17.586 19l-2.293 2.293a1 1 0 001.414 1.414L19 20.414l2.293 2.293a1 1 0 001.414-1.414L20.414 19l2.293-2.293a1 1 0 00-1.414-1.414L19 17.586l-2.293-2.293z",
    fill: "#000"
  })));
}
export default SvgTrailPeriodIsOver;